module.exports = __webpack_public_path__ + "img/green_001.c713b1d1.png";